module.exports = __webpack_public_path__ + "static/media/logo-icesi.d80994e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo-icesi.png
// module id = 574
// module chunks = 0